import styled from 'styled-components'

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/Centered/index.js